// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3gf-R","overflowing":"ReadFullNote_overflowing__1dIld"};